<template>
  <Portal to="loading" :disabled="!full">
    <div class="loading-indicator" :class="{ inline, full }">
      <BallPulseSync color="#039be5" />
    </div>
  </Portal>
</template>

<script>
import { Portal } from 'portal-vue'
import { component as BallPulseSync } from 'vue-loaders/dist/loaders/ball-pulse-sync'

export default {
  name: 'LoadingIndicator',
  components: {
    Portal,
    BallPulseSync,
  },
  props: {
    /** インライン表示 */
    inline: { type: Boolean, default: false },
    /** 全画面表示 */
    full: { type: Boolean, default: false },
  },
}
</script>

<style src="vue-loaders/dist/vue-loaders.css"></style>
<style lang="postcss" scoped>
.loading-indicator {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;

  &.inline {
    height: 64px;
    position: static;
  }

  &.full {
    position: fixed;
  }
}
</style>
